import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { QUERY_KEYS } from '@hero/constants';
import { organizationServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useResendOrganizationUser = options => {
  const { t } = useTranslation();
  const { showSuccess } = useNotification();
  const queryClient = useQueryClient();

  return useMutation(body => organizationServices.resendInviteOrganizationUser(body), {
    onSuccess(_data, variables) {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.useGetOrganizationUsers]
      });
      showSuccess({
        message: t('yourInvitationInWorks', { count: variables?.inviteCodes?.length || 1 }),
        type: 'toast'
      });
    },
    ...options
  });
};
